import Vue from 'vue';
import feathersClient from '../../feathers-client';
import { auto } from '@popperjs/core';

export default {
	state: {
		nudgeTime: [],
		unfilledShiftNudgeTime: [],
	    autoSubmissionTime: [],
		//autoSubmissionTime: [], 
	},
	getters: {

	},
	mutations: {
		SET_NUDGE_TIME: (state, data) => { state.nudgeTime = data; },
		SET_TIER_MAPPING:(state, data) => {state.unfilledShiftNudgeTime = data; },
		//SET_SUBMISSION_TIME: (state, data) => { state.autoSubmissionTime = data; },
		//SET_AUTO_SUBMISSION_TIME: (state, data) => { state.autoSubmissionTime = data; },
	},
	actions: {
		getNudgeTime: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-nudge-timer').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});

			
			commit('SET_TIER_MAPPING', results.data);
			commit('SET_NUDGE_TIME', results.data);
			//commit('SET_SUBMISSION_TIME', results.data);
			return results.data;
		},
		updateNudgeTime: async({ rootGetters, commit }, data) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-nudge-timer').patch(data.id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

		getNudgeTimeById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/unfilled-shifts-nudge-timer').find({
				query: {
					$role: rootGetters.currentUserRole,
				},
			});

			return results;
		},
		createNudgeTime: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-nudge-timer').create(data,{
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
      
	},
};
